<template>
  <div id="app">
    <div :class="['tabbar', isTop ? 'isscroll' : 'noscroll']">
      <!-- <div class="demoText">演示平台</div> -->
      <div class="left">
        <div class="icon">
          <div class="imgLogo"><img src="./assets/logo.png" alt="" /></div>
          <div class="txt">
            <p class="p1">建采得一网</p>
            <p class="p2">JIANCAIDEYIWANG</p>
          </div>
        </div>
      </div>
      <div class="list flex">
        <div :class="{ cur: tab == '/' }" @click="toHome">
          <p>首页</p>
        </div>
        <div :class="{ cur: tab == '/home' }" @click="tonews">
          <p>新闻动态</p>
        </div>
        <!-- <div @click="toProvide">
          <p>供应链平台</p>
          <p>PLATFORM</p>
        </div> -->
        <div :class="{ cur: tab == '/platformIntroduce' }" @click="toIntroduce">
          <p>平台介绍</p>
        </div>
        <div :class="{ cur: tab == '/aboutUs' }" @click="toaboutUs">
          <p>关于我们</p>
        </div>
      </div>
      <!-- <div class="right flex">
        <p>登录</p>
        <p>|</p>
        <p>注册</p>
      </div> -->
      <div class="navicon">
        <!-- <img src="./assets/nav.png" alt="" /> -->
        <img
          v-if="!menushow"
          src="./assets/nav.png"
          alt=""
          @click="showMenu"
          class="showMenu"
        />
        <img
          v-else
          src="./assets/close_menu.png"
          @click="closeMenu"
          class="closeMenu"
        />
      </div>
    </div>
    <!-- 移动端导航 -->
    <div :class="{ menushow: menushow }" class="h5-menu" @touchmove.prevent>
      <div class="tabs">
        <p @click="toHome">首页</p>
        <p @click="tonews">新闻动态</p>
        <!-- <p>供应链平台</p> -->
        <p @click="toIntroduce">平台介绍</p>
        <p @click="toaboutUs">关于我们</p>
      </div>
    </div>
    <router-view />
    <div class="footer">
      <div class="top flex">
        <div class="fd-link">
          <dl>
            <dt>产品服务</dt>
            <dd>
              <a href="https://psp.jiancaideyi.com/">供应商平台</a>
              <a href="https://ssp.jiancaideyi.com/">采购商平台</a>
              <!-- <a href="">项目方平台</a> -->
              <a href="https://bsp.jiancaideyi.com">银行平台</a>
            </dd>
          </dl>
          <dl>
            <dt>关于我们</dt>
            <dd>
              <a href="">公司介绍</a>
              <a href="/platformInformation">平台介绍</a>
            </dd>
          </dl>
          <dl>
            <dt>联系我们</dt>
            <dd>
              <a href="">电话服务：0311-68026032</a>
              <a href="">地址：北京市房山区怡和北路5号院10号楼2层2-07</a>
              <a href="">邮箱：576413089@qq.com</a>
            </dd>
          </dl>
          <dl>
            <dt>关于我们</dt>
            <dd>
              <a href=""
                >关注中采智信网抖音号，关注中采智信网微信公众号，随时随地了解最新资讯。</a
              >
              <div class="code">
                <div class="socal">
                  <img src="./assets/douyin_qrcode.png" alt="" />
                  <!-- <p>中采智信网抖音</p> -->
                </div>
                <div class="socal">
                  <img src="./assets/weixin_qrcode.png" alt="" />
                  <!-- <p>微信公众号</p> -->
                </div>
              </div>
            </dd>
          </dl>
        </div>
      </div>
      <div class="bot">
        <div class="main_box">
          <div class="logo">
            <div class="icon flex">
              <img src="./assets/logo.png" alt="" />
              <p>智信供应链</p>
            </div>
          </div>
          <div class="p2">
            <p>
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener noreferrer"
                style="color: #ffffff"
              >
                ICP备案号：京ICP备2021036269号 </a
              >&nbsp;Copyright © 2023 中采智信信息技术有限公司
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="position_bottom_box">
      <div class="float_window">
        <img src="./assets/icon_helpCenter.png" alt="" />
        <img src="./assets/icon_contractUs.png" alt="" />
        <img src="./assets/icon_publicAccount.png" alt="" />
      </div>
      <div class="back_top_icon" v-if="isTop" @click="backTopEvent">
        <img src="./assets/back_top_icon.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tab: this.$route.path, //初始是进入的路由
      menushow: false,
      oldScrollTop: 0,
      isTop: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrolling);
  },
  methods: {
    scrolling() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let scrollStep = scrollTop - this.oldScrollTop;
      this.oldScrollTop = scrollTop;
      // console.log(scrollTop)
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // if (scrollTop + windowHeight == scrollHeight) {
      //   console.log("已经到底了")
      // }
      // if (scrollStep < 0) {
      //   console.log("滚动条向上滚动了")

      // } else {
      //   console.log("滚动条向下滚动了")
      // }
      if (scrollTop > 323) {
        // console.log("超过轮播图")
        this.isTop = true;
      } else {
        // console.log("没超过------")
        this.isTop = false;
        // console.log(this.isTop)
      }
      // if (scrollTop <= 0) {
      //   console.log("到了最顶部")
      // }
    },
    backTopEvent() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    showMenu() {
      this.menushow = true;
      document.body.style.overflow = "hidden";
    },
    closeMenu() {
      this.menushow = false;
      document.body.style.overflow = "scroll";
    },
    toHome() {
      this.closeMenu();
      this.tab = "/";
      this.$router.push("/");
    },
    tonews() {
      this.closeMenu();
      this.tab = "/home";
      this.$router.push("/home");
    },
    toaboutUs() {
      this.closeMenu();
      this.tab = "/aboutUs";
      this.$router.push("/aboutUs");
    },
    toIntroduce() {
      this.closeMenu();
      this.tab = "/platformIntroduce";
      this.$router.push("/platformIntroduce");
    },
    toProvide() {
      // window.open("http://49.233.123.55:13025")
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrolling);
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

@font-face {
  font-family: "CustomFont";
  src: url("./assets/YouSheBiaoTiHei-2.ttf");
}

.center {
  width: 57%;
  margin: 0 auto;
}

.isscroll {
  background: #0074ff;
}

.noscroll {
  background: transparent;
}

.tabbar {
  width: 100%;
  height: 100px;
  padding: 0 365px;
  box-sizing: border-box;
  color: #ffffff;
  position: fixed;
  z-index: 99;
  top: 0;
  display: flex;
  // background-color: #ffffff;

  .demoText {
    position: absolute;
    left: 20px;
    top: 20px;
    color: rgb(255, 0, 0);
    font-size: 36px;
    font-weight: 600;
  }

  .left {
    display: flex;
    align-items: center;
    width: 25%;

    .icon {
      display: flex;
      align-items: center;

      .imgLogo {
        width: 55px;
        height: 55px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .txt {
        text-align: left;
        margin-left: 5px;

        .p1 {
          font-size: 24px;
          font-weight: 500;
          color: #ffffff;
        }

        .p2 {
          font-size: 10px;
          font-weight: 500;
          color: #ffffff;
          letter-spacing: 0.2em;
        }
      }
    }
  }

  .list {
    width: 40%;
    height: 100%;
    font-size: 16px;

    div {
      p {
        line-height: 36px;
        color: #ffffff;
        opacity: 0.7;
        font-size: 20px;
      }
    }

    .cur {
      p {
        color: #ffffff;
        opacity: 1;
      }

      // display: flex;
      // flex-direction: column;
      // justify-content: center;
      // align-items: center;
    }
  }

  .right {
    width: 5%;
  }

  p {
    cursor: pointer;
  }

  .navicon {
    display: none;
  }
}

.h5-menu {
  display: none;
}

@media screen and (max-width: 750px) {
  .tabbar {
    width: 100%;
    height: 206px;
    background: #0074ff;
    padding: 0 42px 0 54px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .demoText {
      display: none;
    }

    .list,
    .right {
      display: none;
    }

    .navicon {
      display: block;

      .showMenu {
        width: 40px;
        height: 35px;
      }

      .closeMenu {
        width: 44px;
        height: 44px;
      }
    }
  }

  .menushow {
    display: block;
  }

  .h5-menu {
    width: 100vw;
    height: 100vh;
    background: #050409;
    z-index: 9;
    position: fixed;
    top: 0;
    left: 0;
    color: #fff;

    .tabs {
      width: 700px;
      height: 748px;
      margin: 0 auto;
      margin-top: 206px;
      padding: 0 32px;
      box-sizing: border-box;
      border-radius: 25px;

      P {
        font-size: 28px;
        font-weight: 600;
        text-align: left;
        line-height: 120px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }
    }
  }
}

.footer {
  width: 100%;
  height: 521px;
  // background: #2c3445;
  background: #13255a;
  padding: 87px 0 40px;
  box-sizing: border-box;

  .top {
    .fd-link {
      width: 78%;
      overflow: hidden;
      margin: 0 auto;
    }

    .fd-link dl {
      float: left;
      width: 25%;
    }

    .fd-link dt {
      text-align: left;
      margin-bottom: 32px;
      font-size: 18px;
      color: #fff;
    }

    .fd-link dd a {
      text-align: left;
      padding: 10px 0;
      display: block;
      font-size: 14px;
      color: #a6a6a6;
      line-height: 1.5;
      -webkit-transition: 0.3s;
      -o-transition: 0.3s;
      transition: 0.3s;
      word-break: break-all;
    }
    .fd-link dd .code {
      margin-top: 24px;
      display: flex;
      img {
        width: 72px;
        height: 72px;
        background: #d8d8d8;
        border-radius: 2px;
        margin-right: 10px;
      }

      p {
        font-size: 18px;
        color: #ffffff;
        margin-top: 10px;
      }
    }

    .fd-link dd a:hover {
      color: #fff;
    }
  }

  .bot {
    border-top: 1px solid rgba(212, 212, 212, 0.51);
    margin-top: 36px;
    .main_box {
      width: 78%;
      margin: 55px auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .logo {
      .icon {
        img {
          width: 60px;
          height: 60px;
        }

        p {
          font-size: 36px;
          color: #ffffff;
        }
      }
    }

    .p2 {
      font-size: 14px;
      color: #ffffff;
      // margin-top: 30px;
    }
  }
}

@media screen and (max-width: 750px) {
  .footer {
    height: 546px;
    .top {
      .fd-link {
        width: 100%;
      }
    }
  }
  .bot {
    .main_box {
      flex-direction: column;
    }
  }
}
.position_bottom_box {
  position: fixed;
  right: 30px;
  bottom: 100px;
  .float_window {
    width: 68px;
    height: 218px;
    border-radius: 34px;
    box-shadow: 0px 4px 12px 0px #000000;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    background-color: #ffffff;
    img {
      width: 52px;
      height: 46px;
      cursor: pointer;
    }
  }
  .back_top_icon {
    width: 68px;
    height: 68px;
    background-color: #ffffff;
    border-radius: 50%;
    box-shadow: 0px 4px 12px 0px #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    cursor: pointer;
    img {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
